/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import {
  Card,
  Image,
  Navbar,
  Button,
  ButtonGroup,
  Container,
} from 'react-bootstrap';
import { ButtonWithIcon } from '@vlinder-web/button-v2-widget-react';

export interface IVideoModalProps {
  videoSrc?: string;
  title?: string;
  closeTitleLabel?: string;
  closeModal?(): void;
}

export const VideoModal = ({
  videoSrc,
  title,
  closeTitleLabel,
  closeModal,
}: IVideoModalProps) => {
  console.log('ajsj', videoSrc);

  if (videoSrc) {
    //@ts-ignore
    return (
      <>
        <Navbar
          variant="dark"
          bg="dark"
          fixed={'top'}
          className="navbar-transparent navbar-theme-primary"
        >
          <Container className="position-relative justify-content-between px-3">
            {title ? (
              <Navbar.Brand>
                <div>
                  <span>{title}</span>
                </div>
              </Navbar.Brand>
            ) : (
              <div />
            )}
            <div className="d-block mb-4 mb-md-0 justify-content-end">
              <ButtonGroup className="ms-2 ms-lg-3 p-sm-2 p-md-3">
                <ButtonWithIcon
                  title={closeTitleLabel}
                  icon={'XIcon'}
                  iconPosition={'left'}
                  onClick={closeModal}
                  className="bg-secondary"
                />
              </ButtonGroup>
            </div>
          </Container>
        </Navbar>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
            padding: '5px',
          }}
        >
          <video width="100%" height="100%" controls id="video-player">
            <source src={videoSrc} type="video/mp4" />
          </video>
        </div>
      </>
    );
  }
  return null;
};

VideoModal.defaultProps = {
  audioSrc: '',
};
